import api from './api';

const decodeJwt = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return {};
  }
};

export const sendOtp = (phoneNumber, role) =>
  api.post('/auth/login', { phoneNumber, role });

export const verifyOtp = (phoneNumber, role, otp) =>
  api.post('/auth/verify-otp', { phoneNumber, role, otp }).then(async ({ data }) => {
    // CloudFront turns API 403/404s into index.html with a 200, so check for a token
    if (!data?.token) throw new Error('Sign-in failed. Please try again.');
    const claims = decodeJwt(data.token);
    // Fetch full profile to get name, email, and profileCompleted flag
    let profileCompleted = false;
    let fullName = null;
    let email = null;
    try {
      const meRes = await api.get('/me', {
        headers: { Authorization: `Bearer ${data.token}` },
      });
      profileCompleted = meRes.data.profileCompleted ?? false;
      fullName = meRes.data.fullName || null;
      email    = meRes.data.email    || null;
    } catch {
      // If /me is unavailable fall back to JWT data only
    }
    return {
      token: data.token,
      user: { phone: claims.sub, role: claims.role, profileCompleted, name: fullName, email },
    };
  });